import { getLatestHeightWeight, NOT_CALCULATED_LABEL } from './bmi';

export const getAjbwDisplayFromEvents = (
  events: any[] = [],
  genderValue?: unknown,
) => {
  const { heightCm, weightKg, dateStr } = getLatestHeightWeight(events);

  const gender = String(genderValue ?? '')
    .trim()
    .toLowerCase();
  const isMale = gender === 'm' || gender === 'male';
  const isFemale = gender === 'f' || gender === 'female';
  const hasCalculableGender = isMale || isFemale;

  if (!hasCalculableGender || heightCm == null || weightKg == null) {
    return { displayValue: NOT_CALCULATED_LABEL, dateStr };
  }

  const ibw = (isMale ? 50 : 45.5) + 2.3 * (heightCm - 152.4);
  const ajbw = ibw + 0.4 * (weightKg - ibw);

  return {
    displayValue:
      ajbw == null || !Number.isFinite(ajbw)
        ? NOT_CALCULATED_LABEL
        : `${ajbw.toFixed(1)}kg`,
    dateStr,
  };
};
